<template>
  <div class="bgHomePage md-layout" >
    <!--section2 text top-->
    <section v-if="this.current"  class="md-layout-item md-size-100 md-layout " style="margin: 150px 0px 100px 0px;">
        <div class="md-layout-item md-size-100 bgForm gridpadForm md-layout" style="position: relative; height: 100%; padding-top:30px !important; background-color: rgba(10,10,10,0.8); border-top: 10px solid rgb(40, 133, 34); border-bottom: 10px solid rgb(40, 133, 34);">
            <div class="md-layout-item  md-size-100" >
                <div><h2 class="f-white txt-c" style="text-transform: uppercase;">Postuler pour le poste {{ this.current.title }}</h2></div>
            </div>
            <div class="md-layout-item md-size-100 md-layout" style="padding-top: 50px;">
                <div class="md-layout-item md-size-100 md-layout">
                    <form class="md-layout-item md-size-100 md-layout" ref="form">
                    <!--Form-->
                        <div class="md-layout-item md-size-100 md-layout">
                            <div class="md-layout-item md-size-100 md-layout">
                                
                                <div class="md-layout-item md-size-100 md-layout">
                                    <!--name-->
                                    <div class="md-layout-item md-size-50 md-small-size-100 md-layout fieldMin">
                                        <div class="md-layout-item md-size-100 padForm md-layout">
                                            <p :class="{'error': error.name == true }" class="bold f-white" style="font-size: 14px;" >Nom:</p>
                                        </div>
                                        <div class="md-layout-item md-size-100 padForm md-layout">
                                            <md-field  style="background-color: rgba(40, 133, 34,0.8);">
                                                <label>Nom</label>
                                                <md-input id="nameDuCandidat" name="nameDuCandidat" type="text" @change="error.name = false" v-model="item.name" clearable required></md-input> 
                                            </md-field>
                                        </div>
                                    </div>
                                    <!--city-->
                                    <div class="md-layout-item md-size-50 md-small-size-100 md-layout fieldMin">
                                        <div class="md-layout-item md-size-100 padForm md-layout"><p class="bold f-white" style="font-size: 14px;">Adresse</p></div>
                                        <div class="md-layout-item md-size-100 padForm md-layout">
                                            <md-field  style="background-color: rgba(40, 133, 34,0.8);" >
                                                <label>Adresse</label>
                                                <md-input id="AdresseDuCandidat" name="AdresseDuCandidat" type="text" v-model="item.location" clearable required></md-input> 
                                            </md-field>
                                        </div>
                                    </div>
                                    <!--email-->
                                    <div class="md-layout-item md-size-50 md-small-size-100 md-layout fieldMin">
                                        <div class="md-layout-item md-size-100 padForm md-layout">
                                            <p :class="{'error': error.email == true }" class="bold f-white" style="font-size: 14px;" >Courriel:</p>
                                        </div>
                                        
                                        <div class="md-layout-item md-size-100 padForm md-layout">
                                            <md-field  style="background-color: rgba(40, 133, 34,0.8);" >
                                                <label>Courriel</label>
                                                <md-input id="CourrielDuCandidat" name="CourrielDuCandidat" type="text" v-model="item.email" clearable required></md-input> 
                                            </md-field>
                                        </div>
                                    </div>
                                    <!--phone-->
                                    <div class="md-layout-item md-size-50 md-small-size-100 md-layout fieldMin">
                                        <div class="md-layout-item md-size-100 padForm md-layout">
                                            <p :class="{'error': error.phone == true }" class="bold f-white" style="font-size: 14px;" >Téléphone:</p>
                                        </div>
                                        <div class="md-layout-item md-size-100 padForm md-layout">
                                            <md-field  style="background-color: rgba(40, 133, 34,0.8);" >
                                                <label>xxx xxx-xxxx</label>
                                                <md-input id="TelephoneDuCandidat" name="TelephoneDuCandidat" type="text" v-model="item.phone" clearable required></md-input> 
                                            </md-field>
                                            <!--<p class="errorText" v-if="error.phone" style="font-size: 14px; margin-top: -25px;">Un téléphone est requis **</p>-->
                                        </div>
                                    </div>
                                    <!--Description-->
                                    <div class="md-layout-item md-size-100 md-layout fieldFormMax">
                                        <div class="md-layout-item md-size-100 padForm md-layout">
                                            <p :class="{'error': error.message == true }" class="bold f-white" style="font-size: 14px;" >Description de votre CV:</p>
                                        </div>
                                        <div class="md-layout-item md-size-100 padForm md-layout">
                                            <md-field style="background-color: rgba(40, 133, 34,0.8);">
                                                <label>Description</label>
                                                <md-textarea id="descriptionCV" name="descriptionCV" v-model="item.message" clearable required></md-textarea>
                                            </md-field>
                                            <!--<v-textarea  no-resize  label=""  bg-color="green-lighten-4" rows="7" row-height="45" single-line :counter="520" maxlength="520"/>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--accept form-->
                        <div class="md-layout-item md-size-100 md-layout">
                            <div class="md-layout-item md-size-100 md-large-size-50 md-layout">
                                <p v-if="this.Dialog == 'error'" class="" style="color: red; margin-left:15px;" >Il y a eu un probleme dans la demande veuillez recommencer</p>
                            </div>
                            <div class="md-layout-item md-size-100 md-large-size-50 md-layout md-alignment-center-right">
                                <span v-if="this.Dialog != 'send'" @click="SendForm()" class="button" style="margin-right:15px;">
                                    <p class="buttonText2" v-if="this.Dialog == 'notSend' || this.Dialog == 'error'" >Postuler</p>
                                    <p class="buttonText2" v-if="this.Dialog == 'pending'">veuillez patientez pour l'envoie du formulaire</p>
                                </span>
                                <h3 id="ContactFormSent" v-if="this.Dialog == 'send'" class="f-primary" style="text-align: center; font-size: 2em;">La demande à été envoyer !</h3>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

        </div>
    </section>
  </div>
</template>
<style scoped>
    .f-primary { color: rgb(40, 133, 34) !important; }
    .f-white {  color: white;}
    .bgHomePage { height: 100%; background-image: url('../../../public/resources/images/BannerIndexTop.jpg'); background-position: center center; background-size: cover; background-repeat: no-repeat; }
    h2 { font-weight: 700; }
    .section2Text p { font-size: clamp(0.75em,1.5vw,1.25em); line-height:29.26px; text-align: justify; margin: 25px 0px; font-weight: 100; }
    .positionTopContainer { position:relative; z-index:1; top:50px;  min-height: 800px; height: 100%; }
    .topContainer { min-height: 350px; height:auto; background-color: rgba(10, 10, 10,0.8);border-top: 10px solid rgb(40, 133, 34); border-bottom: 10px solid rgb(40, 133, 34); }
    .error { color: red !important; }
    .section2Text p:hover { color: rgb(40, 133, 34) !important; }
    .section2Text a { text-decoration: none !important;}

    /*#region Form*/
        .gridpadForm {padding: 0px 200px; }
        .bgForm {background-color: rgb(var(--tierce2));}
        .fieldMin { min-width: 50%; }
        .fieldFormMax { min-width: 100%; }
        .padForm { padding: 5px 10px;}
        .button {background: rgba(40, 133, 34,0.8) !important; border-radius: 10px; border:none; color:white ; padding:10px 50px;text-align:center;text-decoration:none;display:inline-block;font-size:16px;margin:4px 2px;cursor:pointer;}
        .button:hover {background: rgb(40, 133, 34)!important;}
        .buttonText2 {text-transform: uppercase; font-size:14px !important; color: rgb(255,255,255) !important; font-weight: 700;}
    /*#endregion*/ 

    @media handheld, only screen and (max-width: 600px) {
        .gridpadForm {padding: 50px 10px;}
    }
    @media handheld, only screen and (max-width: 960px) {
        .positionTopContainer { top:50px; }
        .Caroussel { height: unset; margin: 20px auto !important; overflow: hidden; }
        .BGTextCarousselContainer { margin: auto;}
        .imgContainer { margin: auto; }
        .topContainer { max-height: unset; }
    }
    @media handheld, only screen and (max-width: 1279px) {}
    @media handheld, only screen and (max-width: 1378px) {}
</style>
<script>
    import { Carousel, Slide } from 'vue-carousel';
export default {
    name: 'Home',
    data: () => ({
        drawer: false,
        jobs:null,
        current:null,
        item: {
            name: null,
            email: null,
            phone: null,
            address: null,
            message: null
        },
        Dialog: "notSend", //"error, send, notSend"
        error:{
            name: false,
            phone: false,
            email: false,
            message: false
        },
    }),
    async mounted() {
        let UId = this.$route.params.UId;
        console.log(UId);
        //await this.jobsJsonRead();
        if(UId) { await this.dataRead(UId); } else { this.$router.push('/'); }
        
    },
    methods: {
        dataRead: async function (UId) {
            try {
                console.log(UId);
                const response = await fetch('/resources/json/jobs.json');
                if (!response.ok) { throw new Error('Failed to fetch'); }
                this.jobs = await response.json();
                if(this.jobs){this.current = this.jobs[UId]}
            } catch (error) {
                console.error('Error loading JSON data:', error);
            }
        },
        login: async function () {

            let api = 'https://abstracxion.wx3data.com/security/login/Quintech'; // need Tenant BissonService 
            let data = null;
            try {
                let response = await fetch(api, {
                    method: 'PUT', // *GET, POST, PUT, DELETE, etc.
                    mode: 'cors', // no-cors, *cors, same-origin
                    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                    credentials: 'same-origin', // include, *same-origin, omit
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    redirect: 'follow', // manual, *follow, error
                    referrerPolicy: 'no-referrer', // no-referrer, *client
                    body: JSON.stringify({LoginName: "", password: ""}) // body data type must match "Content-Type" header
                })
                if (await response.ok) {
                    if (await response.status !== 204) {
                        let data = await response.text();
                        return data
                    }
                } else {
                    let msg = await response.text();
                    $App.event.$emit("app_error", msg);
                };
                    
            } catch (error) {
                console.log(error);
            }
        },
        SendForm: async function (){
            this.Dialog = "pending";
            let valid = await this.validation();
            if(valid == true){
            let formData = new FormData(this.$refs.form);
            let api = 'https://abstracxion.wx3data.com/eCommerce/Forms/ContactUs/sendByEmail';
            try {
                let token = await this.login();

                // ** ATTENTION need to add bearer token...
                let response = await fetch(api, {
                    method: 'POST',
                    mode: 'cors', // no-cors, *cors, same-origin
                    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                    credentials: 'same-origin', // include, *same-origin, omit
                    headers: {
                        'Authorization': 'Bearer ' + token
                    },
                    redirect: 'follow', // manual, *follow, error
                    referrerPolicy: 'no-referrer', // no-referrer, *client
                    body: formData
                });

                if (await response.ok) {
                    if (await response.status !== 204) {
                        this.Dialog = "send";
                    }
                } else {
                    this.Dialog = "error";
                };

            } catch (error) {

            }
            }else { this.Dialog = 'error'; }

        },
        validation: async function(){
            let valid = true;
            let errorFlag = {name: false, phone: false, email:false, message:false };
            if(this.item.name == null || this.item.name.length == 0){ valid = false; errorFlag.name = true; }
            if(this.item.phone == null || this.item.phone.length < 12){valid = false; errorFlag.phone = true; }
            if(this.item.email == null  || !String(this.item.email).trim().includes('@')){valid = false; errorFlag.email = true; }
            if(this.item.message == null){valid = false; errorFlag.message = true; }
            this.error = errorFlag;
            return valid;
        },
        
    },
    components: { },
}
</script>